import { toast as reactToastify } from "react-toastify";

export const toast = reactToastify;
